const dateFormat = new Intl.DateTimeFormat('bg-BG', {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  timeZone: 'Europe/Sofia',
});

const timeFormat = new Intl.DateTimeFormat('bg-BG', {
  hour: 'numeric',
  minute: 'numeric',
  timeZone: 'Europe/Sofia',
});
const dateTimeFormat = new Intl.DateTimeFormat('bg-BG', {
  year: '2-digit',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  timeZone: 'Europe/Sofia',
});

export function formatDate(
  d: Date | string,
  type: 'date' | 'time' | 'datetime' = 'date',
) {
  const date = d instanceof Date ? d : new Date(d);
  switch (type) {
    case 'time':
      return timeFormat.format(date);
    case 'datetime':
      return dateTimeFormat.format(date);
    default:
      return dateFormat.format(date);
  }
}

export function isTimeAfter(original: string, treshold: string) {
  const [oH, oM] = original.split(':');
  const oMinutes = (Number.isNaN(Number(oM)) ? 0 : Number(oM)) + (Number.isNaN(Number(oH)) ? 0 : (Number(oH) * 60));
  const [tH, tM] = treshold.split(':');
  const tMinutes = (Number.isNaN(Number(tM)) ? 0 : Number(tM)) + (Number.isNaN(Number(tH)) ? 0 : (Number(tH) * 60));
  return oMinutes > tMinutes;
}

export function getDeliveryDate({ date, holidays, hasCourier = false }: { date: Date, holidays: string[], hasCourier?: boolean }): Date {
  const deliveryDate = date ?? new Date();
  let dayShift = 1;

  const currHHmm = deliveryDate.toLocaleString('en-US', {
    timeZone: 'Europe/Sofia',
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
  });
  const isAfterWorkinghours = isTimeAfter(currHHmm, '19:00');
  if (isAfterWorkinghours) {
    dayShift = 2;
  }

  deliveryDate.setDate(deliveryDate.getDate() + dayShift);
  // If the shifted day is in the weekend - keep moving

  while (deliveryDate.getDay() === 0 || deliveryDate.getDay() === 6 || holidays.includes(deliveryDate.toISOString().slice(0, 10))) {
    deliveryDate.setDate(deliveryDate.getDate() + 1);
  }

  // Add +1 additional day when using courier
  if (hasCourier) {
    deliveryDate.setDate(deliveryDate.getDate() + 1);
  }

  // The default time of a order is 13:00
  deliveryDate.setHours(13, 0, 0, 0);

  return deliveryDate;
}
